export default "__VITE_ASSET__o6lg5CXA__"